import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {getSinglePrintfulInfo} from "../../services/printful-info-data.service";
import {PRINTFUL_INFO_IDS} from "../../constants/printful-info.constant";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PRINTFUL_PRODUCT_TYPES_FIELDS_LIST} from "../../constants/printful-product-types.constant";
import {syncPrintfulProductTypes} from "../../../common/services/cloud-function-service";

const defaultFilterCriteria: any = {};

const PrintfulProductTypesList = () => {
    const [printfulProductTypeInfo, setPrintfulProductTypeInfo] = useState(null);
    const [printfulProductTypesList, setPrintfulProductTypesList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulProductTypesList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const printfulProductTypeInfoResult = await getSinglePrintfulInfo(PRINTFUL_INFO_IDS.PRINTFUL_PRODUCT_TYPES);

        printfulProductTypeInfoResult.productTypes = _.orderBy(printfulProductTypeInfoResult?.productTypes, ['type'], ['asc']);
        setPrintfulProductTypeInfo(printfulProductTypeInfoResult);
        setPrintfulProductTypesList(printfulProductTypeInfoResult?.productTypes);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulProductTypesList();
    }, [filterCriteria]);

    const refreshPrintfulProductTypesList = async () => {
        await getPrintfulProductTypesList();
    }

    /*const startPrintfulProductTypesSyncProcess = async () => {
        setDataFetchInProgress(true);
        await syncPrintfulProductTypes();

        await refreshPrintfulProductTypesList();
        setDataFetchInProgress(false);
    }*/

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Product Types
                        {printfulProductTypeInfo &&
                            <span className={'ml-2'}>({printfulProductTypeInfo?.total})</span>
                        }
                    </div>

                    {/*<PrintfulProductTypesFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    {/*<div>
                        <button
                            className="button-green px-4 py-2 flex items-center justify-center"
                            onClick={startPrintfulProductTypesSyncProcess}>
                            <span>Sync Printful Product Types</span>
                        </button>
                    </div>*/}
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulProductTypesList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Product Types'}/>

                    {printfulProductTypesList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PRINTFUL_PRODUCT_TYPES_FIELDS_LIST?.map((printfulProductTypesField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${printfulProductTypesField?.cssClass}`}>{printfulProductTypesField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {printfulProductTypesList?.map((printfulProductTypes, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PRINTFUL_PRODUCT_TYPES_FIELDS_LIST?.map((printfulProductTypesField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${printfulProductTypesField?.cssClass}`}>
                                                {printfulProductTypesField?.optionsMap &&
                                                    <>{printfulProductTypesField?.optionsMap[printfulProductTypes[printfulProductTypesField?.attribute]]?.name}</>
                                                }

                                                {!printfulProductTypesField?.optionsMap &&
                                                    <>
                                                        {printfulProductTypes[printfulProductTypesField?.attribute]}

                                                        {printfulProductTypesField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {printfulProductTypes[printfulProductTypesField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulProductTypesList
